import { Add, Delete } from "@mui/icons-material";
import { LoadingButton } from "@mui/lab";
import { Box, Button, Container, Grid, Paper, Typography } from "@mui/material";
import { useCreateSliderImageMutation, useDeleteSliderImageMutation, useGetSliderImagesQuery } from "api/adminSlice";
import { ConfirmDialog } from "modules/common";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import UploadImageDialog from "./UploadImageDialog";
import { last, split, startsWith } from "lodash";
import { generateCloudinaryLink } from "utils";

export default function AdminSlider() {
  const { t } = useTranslation()

  const { data: images, refetch: refetchImages } = useGetSliderImagesQuery({ limit: 100 })
  const [deleteImage, { isLoading: deleteImageLoading, isSuccess: deleteImageIsSuccess, error: deleteImageError }] = useDeleteSliderImageMutation()

  //===============Create image=================
  const [createImage, { isLoading: createImageLoading, isSuccess: createImageIsSuccess, error: createImageError }] = useCreateSliderImageMutation()
  const [sliderPayload, setSliderPayload] = useState({ image: '' })
  const [openUploadImageDialog, setOpenUploadImageDialog] = useState(false)

  const handleChange = ({ target: { name, value } }) => {
    setSliderPayload((prevState) => ({
      ...prevState,
      [name]: value
    }))
  }

  const createImageHandler = async () => {
    if (!!sliderPayload?.image) {
      setOpenUploadImageDialog(false)
      await createImage(sliderPayload)
      refetchImages()
    }
  }

  //=============Confirm dialog handlers=====================
  const [selectedImage, setSelectedImage] = useState(null)
  const [openConfirmDialog, setOpenConfirmDialog] = useState(false)
  const confirmDeleteImageHandler = (image) => {
    setSelectedImage(image)
    setOpenConfirmDialog(true)
  }

  //=============Delete Image handlers=====================
  const deleteImageHandler = async () => {
    setOpenConfirmDialog(false)
    await deleteImage(selectedImage?.id)
    setSelectedImage(null)
    refetchImages()
  }

  return (
    <Container>

      <UploadImageDialog
        open={openUploadImageDialog}
        onClose={() => setOpenUploadImageDialog(false)}
        handleChange={handleChange}
        onConfirm={createImageHandler}
        value={sliderPayload?.image}
      />

      <ConfirmDialog
        open={openConfirmDialog}
        onClose={() => setOpenConfirmDialog(false)}
        title={t("Warning")}
        content={t("Are you sure you want to delete it?")}
        confirmFn={deleteImageHandler}
      />

      <Box my={10} display="flex" justifyContent="space-between">
        <Box>
          {(createImageIsSuccess || deleteImageIsSuccess) && <Typography color="success.main">{t("Done successfully")}</Typography>}
          {(!!createImageError || !!deleteImageError) && <Typography color="error">{t(createImageError ?? deleteImageError)}</Typography>}
        </Box>
        <LoadingButton
          startIcon={<Add />}
          loading={createImageLoading}
          variant="contained"
          onClick={() => setOpenUploadImageDialog(true)}
          sx={{ textTransform: "none" }}
        >
          {t("Add")}
        </LoadingButton>
      </Box>

      <Grid container spacing={10}>
        {
          images?.docs?.map(image => (
            <Grid item xl={3} lg={3} md={4} sm={6} xs={12} key={image?.id}>
              <Paper elevation={7}>
                <img src={generateCloudinaryLink(image?.image)} height={200} width="100%" style={{ objectFit: "cover", display: "block" }} alt="sliders" />
                <Box>
                  <LoadingButton
                    onClick={() => confirmDeleteImageHandler(image)}
                    loading={selectedImage?.id === image?.id && deleteImageLoading}
                    variant="contained"
                    color="error"
                    fullWidth
                  >
                    <Delete />
                  </LoadingButton>
                </Box>
              </Paper>
            </Grid>
          ))
        }
      </Grid>
    </Container>
  )
}
